"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const TopbarButtonContainer = styled_1.default.button `
  height: 36px;
  border-radius: ${({ flavor, theme }) => (flavor === "outline" || flavor === "filled" ? theme.borderRadius : 18)}px;
  padding: 0px
    ${({ flavor, theme }) => flavor === "outline" || flavor === "filled" ? theme.space.element : theme.space.medium}px;
  border: none;    
  box-shadow ${({ flavor, theme }) => (flavor === "outline" ? ` 0 0 0 1px ${theme.color.text.dark}` : "none")};
  background: ${({ flavor, theme }) => flavor === "filled" ? theme.color.primary : flavor === "outline" ? theme.color.white : "transparent"};
  color: ${({ flavor, theme }) => flavor === "filled" ? theme.color.white : flavor === "outline" ? theme.color.text.dark : theme.color.text.lighter};
  display: flex;
  align-items: center;
  cursor: ${props => (props.disabled ? "auto" : "pointer")};
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  font-size: ${props => props.theme.font.size.small}px;
  :focus {
    outline: none;
    background: ${({ flavor, theme }) => flavor === "outline" || flavor === "filled" ? undefined : theme.color.border.select};
  }
  .no-focus &:focus {
    background: none;
  }
  :hover, .no-focus &:hover:focus {
    background: ${({ flavor, disabled }) => disabled || flavor === "outline" || flavor === "filled" ? undefined : "rgba(0,0,25,0.05)"};
  }
  & svg {
    /** Icons are purely presentational and click events are handled upstream */
    pointer-events: none;
  }
`;
const TopbarButton = (_a) => {
    var { children, icon: Icon, onClick, flavor } = _a, props = __rest(_a, ["children", "icon", "onClick", "flavor"]);
    return (React.createElement(TopbarButtonContainer, Object.assign({}, props, { flavor: flavor, onClick: props.disabled ? undefined : onClick }),
        Icon && React.createElement(Icon, { left: true, size: 12 }),
        children));
};
exports.default = TopbarButton;
//# sourceMappingURL=TopbarButton.js.map